var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DictSelect",
    _vm._g(
      _vm._b(
        {
          attrs: {
            clearable: _vm.clearable,
            filterable: _vm.filterable,
            options: _vm.dictOptions,
          },
          on: { change: _vm.onChange },
          model: {
            value: _vm.formData.selectedValue,
            callback: function ($$v) {
              _vm.$set(_vm.formData, "selectedValue", $$v)
            },
            expression: "formData.selectedValue",
          },
        },
        "DictSelect",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }